import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IUser } from 'projects/common/src/app/interfaces';
import { CacheService, ParameterHandlerService } from 'projects/common/src/app/services';
import { LanguageService } from 'projects/common/src/app/services/parameters';
import { IShift } from 'src/app/modules/core/interfaces';
import { InputDateFormatPipe } from 'src/app/modules/core/pipes/input-date-format.pipe';
import { BooleanStateService } from 'src/app/modules/core/services/boolean-state.service';
import { MachineContextService } from 'src/app/modules/core/services/parameter/machine-context/machine-context.service';
import { DashboardFacade } from 'src/app/modules/core/store/dashboard/dashboard.facade';
import { StateSidebarService } from 'src/app/modules/sidebar/services/state-sidebar.service';
import { IModalInputs } from 'src/app/modules/widget/interfaces/production-type-truck-point';
import { IResponseProdVsPlan } from 'src/app/modules/widget/interfaces/production-vs-plan';
import { ScreenViewService } from 'src/app/modules/widget/services/screen-view.service';
import { CommunicationService } from 'src/app/services/communication';
import { ProductionByStreetChartComponent } from '../../production-by-street/production-by-street-chart/production-by-street-chart.component';
import { ProdVsPlanModalComponent } from '../prod-vs-plan-modal/prod-vs-plan-modal.component';

@Component({
  selector: 'app-prod-vs-plan-chart',
  templateUrl: './prod-vs-plan-chart.component.html',
  styleUrls: ['./prod-vs-plan-chart.component.scss'],
})
export class ProdVsPlanChartComponent extends ProductionByStreetChartComponent implements OnInit {
  public hasData: boolean;
  public dataProdPlan: any;
  constructor(
    public dashboardFacade: DashboardFacade,
    protected progressBarService: BooleanStateService,
    protected communication: CommunicationService,
    protected parameterService: ParameterHandlerService,
    protected sidebarService: StateSidebarService,
    protected cacheService: CacheService,
    protected machineContext: MachineContextService,
    protected langService: LanguageService,
    protected modalService: NgbModal,
    protected inputDatePipe: InputDateFormatPipe,
    protected screenViewService: ScreenViewService,
  ) {
    super(
      dashboardFacade,
      progressBarService,
      communication,
      parameterService,
      sidebarService,
      cacheService,
      machineContext,
      langService,
      modalService,
      inputDatePipe,
      screenViewService,
    );
  }

  /**
   * On init component
   */
  public ngOnInit(): void {
    super.ngOnInit();
    this.buildRequestParams();
  }

  /**
   * Function to build needed params
   */
  protected buildRequestParams(): any {
    const shift = this.parameterService.parameters.item('shift').value as IShift;
    const companyId = (this.parameterService.parameters.item('user-data').value as IUser).company.id;
    const dateValue = this.parameterService.parameters.item('date').value as string;
    const { zoneId } = this.cacheService.session('selectedZone');
    const resultType = 2;

    return {
      inputDate: dateValue,
      shiftId: shift.shiftId,
      companyId,
      zoneId,
      resultType,
    };
  }

  /**
   *  drawView Chart
   *
   * @param chartOptions
   */
  public async drawView(chartOptions: IResponseProdVsPlan): Promise<void> {
    this.date = this.parameterService.parameters.item('date').value;
    const shift = this.parameterService.parameters.item('shift').value as IShift;

    this.dataProdPlan = chartOptions;
    if (this.dataProdPlan) {
      this.setChartConfig(shift, this.dataProdPlan, this.typeActive);
      this.hasData = true;
    } else {
      this.hasData = false;
    }
  }

  /**
   * Function to build series for display chart values
   *
   * @param prodByStreetList data to fill chart view
   */
  protected buildSeriesForChart(prodByStreetList: any): any {
    return [
      {
        name: this.langService.message('non-schedule'),
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.doneLoops.nonSchedule };
        }),
        color: '#29BCDE80',
        borderColor: '#29BCDE',
        borderWidth: 2,
        states: {
          hover: {
            color: '#29BCDE',
          },
        },
        stack: 'doneLoops',
      },
      {
        name: this.langService.message('total-shelves'),
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.doneLoops.done };
        }),
        color: '#22D98380',
        borderColor: '#22D983',
        borderWidth: 2,
        states: {
          hover: {
            color: '#22D983',
          },
        },
        stack: 'doneLoops',
      },
      {
        name: this.langService.message('remnant-shelves'),
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.toDoneLoops.remainder };
        }),
        color: '#D3721880',
        borderColor: '#D37218',
        borderWidth: 2,
        states: {
          hover: {
            color: '#D37218',
          },
        },
        stack: 'toDoneLoops',
      },
      {
        name: this.langService.message('scheduled-shelves'),
        data: prodByStreetList.productionByStreet.map((production) => {
          return { id: production.zoneId, y: production.toDoneLoops.scheduled };
        }),
        color: '#AFAFAF80',
        borderColor: '#AFAFAF',
        borderWidth: 2,
        states: {
          hover: {
            color: '#AFAFAF',
          },
        },
        stack: 'toDoneLoops',
      },
    ];
  }

  /**
   *  open modal
   *
   * @param inputs
   */
  protected openModal(inputs: IModalInputs): void {
    const modalRef = inputs.modalSvc.open(ProdVsPlanModalComponent, { centered: true, size: 'lg', windowClass: 'prod-street-modal-width' });
    modalRef.componentInstance.modalSubtitle = inputs.shiftName;
    modalRef.componentInstance.shift = inputs.shift;
    modalRef.componentInstance.streetId = inputs.id;
    modalRef.componentInstance.streetName = inputs.category;
    modalRef.componentInstance.date = inputs.date;
    modalRef.componentInstance.shiftLabel = inputs.shiftName;
    modalRef.componentInstance.zoneName = inputs.zoneName;
  }
}
